<template>
    <div name="media-soldoc" class="media-soldoc">
        <div class="media-inner">
            <div class="section-header">
                <strong class="title">미디어에 소개된 솔닥</strong>
            </div>

            <div class="carousel-container">
                <carousel
                    :perPage="1"
                    :pagination-enabled="false"
                    :navigation-enabled="false"
                    :loop="false"
                    :scrollPerPage="false"
                    ref="carousel"
                >
                    <slide
                        v-for="(card, index) in originalCards"
                        :key="index"
                        class="slide-card"
                    >
                        <div class="card-inner">
                            <div class="card-img">
                                <img :src="card.images" :alt="card.alt" />
                            </div>
                            <div class="cont-area">
                                <span
                                    class="card-category"
                                    v-html="card.category"
                                >
                                </span>
                                <strong
                                    class="card-tit"
                                    v-html="card.cardTit"
                                ></strong>

                                <span class="source">{{ card.source }}</span>
                            </div>
                        </div>
                    </slide>
                </carousel>
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
    name: "media-soldoc",
    components: {
        Carousel,
        Slide,
    },
    data() {
        return {
            originalCards: [
                {
                    id: 0,
                    images: require("../../assets/partners_mobile/img_media01.png"),
                    alt: "NH농협은행, 디지털 헬스케어 전문기업 솔닥과 업무협약",
                    category: "PARTNERSHIP",
                    cardTit:
                        "NH농협은행, 디지털 헬스케어<br> 전문기업 솔닥과 업무협약",
                    source: "아시아경제 | 2023.11.22",
                },
                {
                    id: 1,
                    images: require("../../assets/partners_mobile/img_media02.png"),
                    alt: "대구 비대면진료 시범운영 관련 MBC 뉴스 보도",
                    category: "NEWS",
                    cardTit: "대구 비대면진료 시범운영 관련<br>MBC 뉴스 보도",
                    source: "대구MBC | 2023.11.01",
                },
                {
                    id: 2,
                    images: require("../../assets/partners_mobile/img_media03.png"),
                    alt: "솔닥, 지자체 최초 비대면진료 사업 호응 얻으며 순항",
                    category: "ARTICLE",
                    cardTit:
                        "솔닥, 지자체 최초 비대면진료<br>사업 호응 얻으며 순항",
                    source: "한국경제 | 2023.10.26",
                },
                {
                    id: 3,
                    images: require("../../assets/partners_mobile/img_media04.png"),
                    alt: "솔닥, 누적 100억원 투자로 디지털 인프라 확장",
                    category: "INVESTMENT",
                    cardTit: "솔닥, 누적 100억원 투자로<br>디지털 인프라 확장",
                    source: "마이데일리 | 2023.10.05",
                },
                {
                    id: 4,
                    images: require("../../assets/partners_mobile/img_media05.png"),
                    alt: "솔닥, 대구시 남구청과 비대면진료 인프라 구축 협약",
                    category: "PARTNERSHIP",
                    cardTit:
                        "솔닥, 대구시 남구청과<br>비대면진료 인프라 구축 협약",
                    source: "조선BIZ | 2023.09.18",
                },
                {
                    id: 5,
                    images: require("../../assets/partners_mobile/img_media06.png"),
                    alt:
                        "솔닥, 시니어 라이프 토털 솔루션 업체 ‘대교뉴이프’와 업무협약",
                    category: "PARTNERSHIP",
                    cardTit:
                        "솔닥, 시니어 라이프 토털 솔루션<br>업체 ‘대교뉴이프’와 업무협약",
                    source: "스포츠월드 | 2023.08.31",
                },
                {
                    id: 6,
                    images: require("../../assets/partners_mobile/img_media07.png"),
                    alt:
                        "솔닥&케어링, 노년층 환자 대상비대면진료 제공 업무협약 체결",
                    category: "PARTNERSHIP",
                    cardTit:
                        "솔닥&케어링, 노년층 환자 대상<br>비대면진료 제공 업무협약 체결",
                    source: "아시아경제 | 2023.05.03",
                },
                {
                    id: 7,
                    images: require("../../assets/partners_mobile/img_media08.png"),
                    alt: "2023 4차 산업혁명 파워코리아 보건복지부 장관상 수상",
                    category: "AWARD",
                    cardTit:
                        "2023 4차 산업혁명 파워코리아<br>보건복지부 장관상 수상",
                    source: "한국경제 | 2023.07.17",
                },
            ],
            activeIndex: 0,
            carouselRef: null,
            isPrevButtonVisible: true,
            isNextButtonVisible: true,
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs.carousel.goToPage(0);
            const carouselWrapper = this.$refs.carousel.$el.querySelector(
                ".VueCarousel-wrapper"
            );
            if (carouselWrapper) {
                carouselWrapper.style.overflow = "visible";
            }
        });

        $(window).scroll(function() {
            var height = $(document).scrollTop();
            var innerTop = $(".media-inner").offset().top;
            var aniTit = $(".media-inner .title");
            var aniItem = $(".media-inner .carousel-container");

            if (height <= innerTop - 1500) {
                $(aniTit).css("display", `none`);
                $(aniItem).css("display", `none`);
            } else if (height > innerTop - 800 && height < innerTop + 1500) {
                $(aniTit).css("display", `block`);
                $(aniItem).css("display", `block`);
            } else if (height > innerTop + 1800) {
                $(aniTit).css("display", `none`);
                $(aniItem).css("display", `none`);
            }
        });
    },
    methods: {
        goToPrevSlide() {
            const currentPage = this.$refs.carousel.currentPage;

            if (currentPage > 0) {
                const targetPage = currentPage - 1;
                this.$refs.carousel.goToPage(targetPage);
                this.isPrevButtonVisible = targetPage !== 0;
            }
            this.isNextButtonVisible = true;
        },
        goToNextSlide() {
            const currentPage = this.$refs.carousel.currentPage;
            const totalPages = this.$refs.carousel.pageCount;

            if (currentPage < totalPages - 1) {
                const targetPage = currentPage + 1;
                this.$refs.carousel.goToPage(targetPage);
                this.isNextButtonVisible = targetPage !== 5;
            }

            this.isPrevButtonVisible = true;
        },
        // onSlideChange() {
        //     // this.isPrevButtonVisible = this.$refs.carousel.currentPage >= 0;
        // },
    },
};
</script>

<style scoped>
.media-soldoc {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 726px;
    background: #fff;
}
.media-soldoc .media-inner {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    padding: 99px 20px;
    z-index: 1;
    overflow: visible;
}
.media-inner .section-header {
    width: 100%;
    text-align: center;
}
.media-inner .title {
    display: none;
    font-size: 32px;
    font-weight: 600;
    line-height: 44px;
    color: #1a1a1a;
    text-align: center;
    animation: fadeInUp2 2s;
}
.media-inner .carousel-container {
    /* display: none; */
    position: relative;
    width: 318px;
    height: 412px;
    margin-top: 65px;
    overflow: visible;
    animation: fadeInUp2 2s;
}
.media-inner .slide-card {
    width: 300px;
    height: 412px;
    padding: 0 8px;
}
.media-inner .slide-card .card-img {
    width: 100%;
    height: 238px;
    overflow: hidden;
}
.media-inner .slide-card .card-img img {
    width: 100%;
}
.custom-arrows {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    display: flex;
    justify-content: space-between;
}
.media-inner .card-inner {
    width: 100%;
    height: 412px;

    border-radius: 16px;
    border: 1px solid #ccc;
    background: #fff;
    overflow: hidden;
}
.media-inner .cont-area {
    padding: 16px 24px;
}
.media-inner .card-category {
    display: block;
    font-size: 12px;
    font-weight: 600;
    line-height: 28px;
    color: #008def;
}
.media-inner .card-tit {
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
    color: #1a1a1a;
}
.media-inner .source {
    display: block;
    margin-top: 18px;
    font-size: 13px;
    font-weight: 400;
    line-height: 28px;
    color: #999;
}
/* 
.arrow-prev,
.arrow-next {
    position: absolute;
    width: 48px;
    height: 48px;
    text-indent: -9999px;
    border: none;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.5);
    transform: translateY(-50%);
    z-index: 10;
} */
/* .arrow-prev {
    left: 0;
    background-image: url(../../assets/partners_mobile/ico_chevron_left.png);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 28px auto;
}
.arrow-next {
    right: 0;
    background-image: url(../../assets/partners_mobile/ico_chevron_right.png);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 28px auto;
} */

@keyframes fadeInUp2 {
    0% {
        opacity: 0;
        transform: translate3d(0, 30%, 0);
    }
    to {
        opacity: 1;
        transform: translateZ(0);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile_partners/MediaSoldoc.vue